(() => {
  const styleId = 'bikiniyes-redo-left';
  let retryTimer;
  let retryCount = 0;
  let rootObserver;
  const install = () => {
    const host = document.getElementById('redo-chat-widget');
    const root = host && host.shadowRoot;
    if (!root) {
      if (host && !retryTimer && retryCount < 40) {
        retryCount += 1;
        retryTimer = setTimeout(() => {
          retryTimer = undefined;
          install();
        }, 250);
      }
      return;
    }
    bodyObserver.disconnect();
    if (retryTimer) clearTimeout(retryTimer);
    if (!root.getElementById(styleId)) {
      const style = document.createElement('style');
      style.id = styleId;
      style.textContent = '#redo-chat-widget-container > [data-arbiter="Flex"] { left: max(16px, env(safe-area-inset-left)) !important; right: auto !important; align-items: flex-start !important; --widget-x: 0px !important; } @media (max-width: 480px) { #redo-chat-widget-container > [data-arbiter="Flex"] { left: max(12px, env(safe-area-inset-left)) !important; } }';
      root.appendChild(style);
    }
    if (!rootObserver) {
      rootObserver = new MutationObserver(install);
      rootObserver.observe(root, { childList: true });
    }
  };
  const bodyObserver = new MutationObserver(install);
  bodyObserver.observe(document.body, { childList: true });
  install();
})();
